import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PageHeadingService } from 'src/app/services/page-heading-service/page-heading.service';
import { MenuUtils } from 'src/app/utils/menu-utils';
import { OnlineMeeting } from '../../models/online-meeting';
import { OnlineMeetingsService } from '../../services/online-meetings.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-online-meetings',
  templateUrl: './online-meetings.component.html',
  styleUrls: ['./online-meetings.component.scss']
})
export class OnlineMeetingsComponent extends ComponentBase implements OnInit {

  constructor(private pageHeadingService: PageHeadingService
    , private onlineMeetingsService: OnlineMeetingsService
    , private datepipe: DatePipe) {
    super();
  }

  todaysdate: string = new Date().toISOString().split('T')[0];
  scheduledMeetings: Array<OnlineMeeting>;
  loading: boolean = true;
  todaysMeetings: Array<OnlineMeeting> = [];
  groupedMeetings: any;
  public config: PerfectScrollbarConfigInterface = {};

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Online Meetings"));
    let sub = this.onlineMeetingsService.getUpcomingMeetings().subscribe(res => {
      this.loading = false;
      this.scheduledMeetings = res['upcoming_meetings'];
      this.scheduledMeetings.forEach(meeting => {
        if (this.CanJoinMeeting(meeting)) {
          meeting.can_join = true;
        }
        else {
          meeting.can_join = false;
        }
      });
      this.todaysMeetings = this.scheduledMeetings.filter(o => (new Date(o.start_time).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)) || (o.is_recurring && new Date(o.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0))).sort((a, b) => (this.getTimeFromDate(a.start_time) > this.getTimeFromDate(b.start_time) ? 1 : -1));
      this.groupedMeetings = this.groupByDate(this.scheduledMeetings.filter(o => !this.todaysMeetings.includes(o)).sort((a, b) => (a.start_time > b.start_time ? 1 : -1)));
    });
    this.addSubscription(sub);
  }

  groupByDate(array: Array<OnlineMeeting>) {
    var groups = {};
    array.forEach(function (o) {
      var group = new Date(o.start_time).setHours(0, 0, 0, 0);
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(key => ({ key, value: groups[key] })).sort((a, b) => (a.key > b.key ? 1 : -1));
  }

  CanJoinMeeting(meeting: OnlineMeeting) {
    if (!meeting.is_recurring && new Date(meeting.start_time).getTime() <= new Date().getTime()) {
      return true;
    }
    else if (meeting.is_recurring && new Date(meeting.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
      return true;
    }
    else {
      return false;
    }
  }

  getTimeFromDate(date: Date): string {
    let new_date = new Date(date);
    return this.datepipe.transform(new_date, 'HH:mm');
  }
}
